module.exports = "# Mission Assignment\n\nTitle: Assembly Mission\n\n## Notes\n\n&nbsp;\n\n\n# Instructions\n\n## Content\n\n### Your mission:\n\n1. Practice your Superhero Calming Breath\n2. Talk to your family about Emergency Preparedness and tell them about the Alertable app\n3. Know your community - they are the ones with you in an emergency!\n\n## Notes\n\n&nbsp;\n"


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridAssembly/sections/70_missionAssignment/level1_assemblyMission.md
// module id = 1528
// module chunks = 2